// Campus photo for /colleges/rice-university: Public domain, by Daderot, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ARice_University_-_Rice_statue_with_Lovett_Hall.JPG), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/rice-university/; credited under the photo.
const photo = {
    "slug": "rice-university",
    "alt": "Lovett Hall behind the statue of William Marsh Rice on the academic quad at Rice University in Houston, Texas",
    "src": "/colleges/rice-university/campus-1600.webp",
    "srcSmall": "/colleges/rice-university/campus-800.webp",
    "srcMid": "/colleges/rice-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/rice-university/og.jpg",
    "title": "Rice University - Rice statue with Lovett Hall",
    "author": "Daderot",
    "license": "Public domain",
    "licenseUrl": null,
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ARice_University_-_Rice_statue_with_Lovett_Hall.JPG",
    "read": "2026-10-01"
};

export default photo;
